@if (isSmallScreen && showMobileBurger) {
  <button type="button" class="sg-sidenav-burger" aria-label="Open menu" (click)="toggleMenu()">
    <mat-icon>menu</mat-icon>
  </button>
}
<mat-sidenav-container #sidenavContainer [class.floating-panel-container]="isFloatingSideBar" [autosize]="!isSmallScreen" class="sg-sidenav sg-flex-auto">
  <mat-sidenav
    #lSidenav
    [ngClass]="{ 'sg-sidenav-small': isSmallScreen, 'floating-panel': isFloatingSideBar }"
    [mode]="mode"
    opened="true"
    [disableClose]="disableCloseSideNav">
    @if ({ sidenavComponent: sidenavService.sideNavComponent$ | async }; as data) {
      @if (data.sidenavComponent) {
        <ng-container *ngTemplateOutlet="customComponentSidenav; context: { $implicit: data.sidenavComponent }"></ng-container>
      } @else {
        <sg-nav-menu
          [ngStyle]="{ 'background-image': backgroundImageSrc ? 'url(' + backgroundImageSrc + ')' : '' }"
          [showExpander]="!isSmallScreen && expenderEnabled"
          [showLogo]="showLogo"
          [showAppName]="showAppName"
          [logoSrc]="logoSrc"
          [appName]="appName"
          [expanderPosition]="expanderPosition"
          [showUserMenu]="showUserMenu"
          [isFloatingSideBar]="isFloatingSideBar"
          [showNotifications]="showNotifications"
          [navBarHomeLink]="navBarHomeLink"></sg-nav-menu>
      }
    }
  </mat-sidenav>
  <mat-sidenav
    #rSidenav
    [mode]="initialSideNavMode$ | async"
    position="end"
    (openedChange)="onRightSidenavOpenedChange($event)"
    [disableClose]="disableCloseSideNav"
    [class.floating-right-side-bar]="isFloatingSideBar">
    <router-outlet name="sgMainSidenav" sgAuxRouteBridgeOutlet="sgMainSidenav"></router-outlet>
  </mat-sidenav>
  <mat-sidenav-content [class.loading]="isLoading" [class.menu-maximized]="isExpanded" [class.menu-minimized]="!isExpanded">
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
<ng-template #customComponentSidenav let-data><ng-container *ngTemplateOutlet="data"></ng-container></ng-template>
